import {
  REGENERATE_SECKEY_NOT_AVAILABLE,
  REGENERATE_SECKEY_INVALID_TOKEN,
  REGENERATE_SECKEY_WRONG_PASSWORD,
  REGENERATE_SECKEY_SUCCESS,
  RESET_REGENERATE_SECKEY,
  DASHBOARD_DETAILS_SUCCESS,
  ACTIVITY_LOG_SUCCESS,
  ADD_CARD_SUCCESS,
  GET_WITHDRAW_DETAILS_SUCCESS,
  GET_PAYMENT_MODE_SUCCESS,
  CHANGE_PASSWORD_SUCCESS,
  CANCEL_PENDINGLIST_SUCCESS,
  TRANSACTION_SUCCESS,
  SEND_MONEY_SUCCESS,
  REQUEST_MONEY_SUCCESS,
  PENDING_LIST_SUCCESS,
  SEND_PENDINGLIST_SUCCESS,
  UPDATE_PROFILE_SUCCESS
} from "../types";

const initialState = {
  notAvailable: false,
  invalidToken: false,
  wrongPassword: false,
  success: false,
  data: {}
};

export default (state = initialState, action) => {
  switch (action.type) {
    case REGENERATE_SECKEY_NOT_AVAILABLE:
      return {
        ...state,
        notAvailable: true,
        invalidRequest: false,
        wrongPassword: false,
        success: false,
        data: action.payload
      };
    case REGENERATE_SECKEY_INVALID_TOKEN:
      return {
        ...state,
        notAvailable: false,
        invalidToken: true,
        wrongPassword: false,
        success: false,
        data: action.payload
      };

    case REGENERATE_SECKEY_SUCCESS:
      return {
        ...state,
        notAvailable: false,
        invalidToken: false,
        wrongPassword: false,
        success: true,
        data: action.payload
      };

    case REGENERATE_SECKEY_WRONG_PASSWORD:
      return {
        ...state,
        notAvailable: false,
        invalidToken: false,
        wrongPassword: false,
        success: true,
        data: action.payload
      };

    case TRANSACTION_SUCCESS:
    case DASHBOARD_DETAILS_SUCCESS:
    case ACTIVITY_LOG_SUCCESS:
    case ADD_CARD_SUCCESS:
    case GET_WITHDRAW_DETAILS_SUCCESS:
    case GET_PAYMENT_MODE_SUCCESS:
    case CHANGE_PASSWORD_SUCCESS:
    case CANCEL_PENDINGLIST_SUCCESS:
    case SEND_PENDINGLIST_SUCCESS:
    case SEND_MONEY_SUCCESS:
    case REQUEST_MONEY_SUCCESS:
    case PENDING_LIST_SUCCESS:
    case UPDATE_PROFILE_SUCCESS:
      return (state = initialState);

    case RESET_REGENERATE_SECKEY:
      return (state = initialState);

    default:
      return state;
  }
};
